const setIsCreatedNewAttended = (state, payload) => {
  state.isCreatedNewAttended = payload
}

export default {
  setIsCreatedNewAttended,
}
